import { useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';

import { bannerContentsServices } from '!core/redux';
import { TrlScreenSummary, TrlTextWithLink } from '»components/atoms';
import { useHandleSagaError } from '»utils/customHooks';

import { BoxStyled, TypographyTitleStyled } from './TrlClientSupport.styles';

export const TrlClientSupport = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const [clientSuport, setClientSuport] = useState({
    title: '',
    bodyShort: '',
  });

  const { handleSagaError } = useHandleSagaError();

  const fetchClientSupport = () => {
    bannerContentsServices
      .getBannerContents({ bannerCode: 'APOIO_CLIENTE' })
      .then((resp) => {
        const [{ title, bodyShort }] = resp;
        setClientSuport({ title, bodyShort });
      })
      .catch((error) => {
        handleSagaError(error);
      });
  };

  useEffect(() => {
    fetchClientSupport();
  }, []);

  return (
    <>
      {isMobile ? (
        <TrlScreenSummary title="TRLT_UI-CUSTOMER_SUPPORT" hasTopMargin>
          <TrlTextWithLink mainText={clientSuport.title} />
        </TrlScreenSummary>
      ) : (
        <TrlTextWithLink mainText={clientSuport.title} />
      )}
      <BoxStyled>
        <TypographyTitleStyled variant="body1" component="div">
          <div dangerouslySetInnerHTML={{ __html: clientSuport.bodyShort }} />
        </TypographyTitleStyled>
      </BoxStyled>
    </>
  );
};
